type BufferLike = {
  from: (input: string, encoding: string) => { toString: (encoding: string) => string };
};

const globalBuffer = (globalThis as { Buffer?: BufferLike }).Buffer;

const decodeBase64Url = (value: string) => {
  let normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padding = normalized.length % 4;
  if (padding) {
    normalized += '='.repeat(4 - padding);
  }

  if (typeof atob === 'function') {
    return atob(normalized);
  }

  if (globalBuffer) {
    return globalBuffer.from(normalized, 'base64').toString('binary');
  }

  throw new Error('Base64 Dekodierung ist in dieser Umgebung nicht verfügbar.');
};

export const extractJwtExpiration = (token: string): number | null => {
  const payload = token.split('.')[1];
  if (!payload) {
    return null;
  }

  try {
    const decoded = decodeBase64Url(payload);
    const parsed = JSON.parse(decoded) as { exp?: number };

    if (typeof parsed.exp === 'number') {
      return parsed.exp * 1000;
    }

    return null;
  } catch (error) {
    console.warn('Konnte JWT nicht dekodieren.', error);
    return null;
  }
};

export const isJwtExpired = (token: string): boolean => {
  const expirationTime = extractJwtExpiration(token);
  if (!expirationTime) {
    return false;
  }

  return Date.now() >= expirationTime;
};
